export const PHOTO_BOOK_STORAGE_KEY = 'photo-book'
export const ACCOUNT_PHOTO_BOOK_STORAGE_KEY = 'account-photo-book'
